// Helpers de validación de formularios (Gap 3 — Sprint UX P2).
// Mantenemos lógica simple e in-line por formulario para no esconder reglas de negocio.

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (v) => !v || EMAIL_REGEX.test(String(v).trim());

export const required = (v) => {
  if (v == null) return false;
  if (typeof v === 'string') return v.trim().length > 0;
  if (Array.isArray(v)) return v.length > 0;
  return Boolean(v);
};

/**
 * Ejecuta un objeto de reglas { campo: () => mensaje|null } y devuelve
 * { errors: {campo: mensaje}, hasError: boolean, primero: campo|null }.
 */
export const runValidations = (rules) => {
  const errors = {};
  let primero = null;
  for (const [campo, fn] of Object.entries(rules)) {
    const msg = fn();
    if (msg) {
      errors[campo] = msg;
      if (!primero) primero = campo;
    }
  }
  return { errors, hasError: Object.keys(errors).length > 0, primero };
};

/** Clase CSS roja para resaltar inputs inválidos. */
export const ERROR_INPUT_CLS = 'border-rose-400 focus-visible:ring-rose-300 ring-rose-200';
